// @ts-strict-ignore
import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {ICON_PROPERTIES_BY_SIZE, IconSizeType} from 'common/constants';
import {Placement} from 'common/components/tooltip/types';

import {template} from './template';
import css from './index.inline.styl';

interface OrganizationIconJsxProps {
  attrs?: {
    'disable-tooltip'?: boolean;
    size?: string;
    'tooltip-text'?: string;
    'tooltip-placement'?: Placement;
  };
}

export class OrganizationIcon extends Component<null, OrganizationIconJsxProps['attrs']> {
  static get attrsSchema(): AttrsSchema<OrganizationIconJsxProps['attrs']> {
    return {
      'disable-tooltip': `boolean`,
      size: {type: `string`, default: IconSizeType.Medium, enum: Object.values(IconSizeType)},
      'tooltip-text': `string`,
      'tooltip-placement': {type: `string`, default: `top`},
    };
  }

  get config() {
    return {
      css,
      useShadowDom: true,
      template,
      helpers: {
        getIconProperties: () => this.getIconProperties(),
        isTooltipEnabled: () => {
          return !this.attr(`disable-tooltip`) && this.attr(`tooltip-text`);
        },
      },
    };
  }

  getIconProperties() {
    return ICON_PROPERTIES_BY_SIZE[this.attr(`size`)];
  }
}

export const OrganizationIconEl = defineAndMakeJsxFactory<OrganizationIconJsxProps>(
  `mp-organization-icon`,
  OrganizationIcon,
);
export const OrganizationIconReact = panel2react<OrganizationIconJsxProps>(`mp-organization-icon`, OrganizationIcon);
